import React from 'react';
import { Box } from '@mui/material';
import CompanyLogo from '../../resources/images/ITK_Envirolab-Core-on-WHT_RGB.png'
import PageTitle from '../components/PageTitle';
import UserSpendTile from './components/UserSpendTile';
import UserWipTile from './components/UserWipTile';
import UserSamplesSubmittedTile from './components/UserSamplesSubmittedTile';
import UserOnTimeReportingTile from './components/UserOnTimeReportingTile';
import UserAverageTatTile from './components/UserAverageTatTile';

import './Dashboard.scss';

const Dashboard = () => {
  return (
    <>
      <PageTitle pageTitle="Dashboard" />

      <Box className="dashboardLogo">
        <img src={CompanyLogo} alt="Company logo" />
      </Box>

      <Box className="dashboardTopRow">
        <UserAverageTatTile />
        <UserOnTimeReportingTile />
      </Box>
      <Box className="dashboardBottomRow">
        <UserWipTile/>
        <UserSamplesSubmittedTile />
        <UserSpendTile/>
      </Box>
    </>
  );
};

export default Dashboard;
